import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions } from '_api/types';

export const GET_PATIENT_GENDER_IDENTITY = 'get-patient-gender-identity';

export const useGetPatientGenderIdentity = () =>
  useGetQuery<ConstantsNameDescriptions<string>[]>(
    () => `/constant/gender`,
    {},
    [GET_PATIENT_GENDER_IDENTITY],
    {
      refetchOnWindowFocus: false,
    },
  );
